import { render, staticRenderFns } from "./DocumentItemCardBySupp.vue?vue&type=template&id=1557b037&scoped=true"
import script from "./DocumentItemCardBySupp.vue?vue&type=script&lang=js"
export * from "./DocumentItemCardBySupp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1557b037",
  null
  
)

export default component.exports